import { render, staticRenderFns } from "./order.vue?vue&type=template&id=6db549e6&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=6db549e6&prod&lang=scss"
import style1 from "./order.vue?vue&type=style&index=1&id=6db549e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db549e6",
  null
  
)

export default component.exports